/*
 * @Date: 2022-05-31 11:57:57
 * @LastEditTime: 2022-06-24 10:34:53
 * @Description:
 */
import * as React from 'react'
import * as Styles from './Nav.style'
import {HttpServer} from '@/services/server'
import {classes} from 'typestyle'

interface NavState {
    type: string,
    icons: Icon[],
    init: boolean,
    isShowRedPot: boolean
}

interface Icon {
    active: string,
    normal: string
}

const ifError = {
        type: 'normal',
        icons: [
            {
                normal: 'https://static-cos.lycheer.net/picture/11285307_a79879ddfcc279e4ed42318fde1ff933.jpg',
                active: 'https://static-cos.lycheer.net/picture/11285307_ff03fa9eb15f5bd7c348ec265858163c.jpg'
            }, {
                normal: 'https://static-cos.lycheer.net/picture/12209467_d308224fd8c5d7e42c6d9862257c96fc.jpg',
                active: 'https://static-cos.lycheer.net/picture/12209467_3ad9206b907ff1a29e15d00cceb8a9c7.jpg'
            }, {
                normal: 'https://static-cos.lycheer.net/picture/11285307_3bed0c0c415b08ee44d3e71b87ecb74b.jpg',
                active: 'https://static-cos.lycheer.net/picture/11285307_76cfc5ce31b05c6cd4897b2ac955f885.jpg'
            }
        ]
}

export default class Nav extends React.Component <{}, NavState> {
    public state: NavState = {
        type: '',
        icons: [],
        init: false,
        isShowRedPot: false
    }

    public async componentDidMount() {
        try {
           const res = await HttpServer.getNavIcon()
           if (res.data.code === 0) {
                    this.setState({...res.data.data, init: true})
                } else {
                    this.setState({...ifError, init: true})
                }

        } catch (err) {
            this.setState({...ifError, init: true})
        }

        const getRedPot = window.localStorage.getItem('WKnav/red/dots')

        if (!getRedPot || (getRedPot && new Date().toLocaleDateString() !== getRedPot)) {
            this.setState({
                isShowRedPot: true
            })
        }
    }

    public linkTo(val: string) {
        window.location.assign(window.location.origin + val)
    }

    public render() {
        if (!this.state.init) {
            return null
        }
        return (
            <div>
                <div className={classes(Styles.Nav, this.state.type === 'special' && Styles.SpecialIconStyle)}>
                    <div className={Styles.NavItem}>
                        <img className={Styles.NavItemIcon} src={this.state.icons[0].active} alt=""/>
                    </div>
                    <div className={Styles.NavItem} onClick={this.linkTo.bind(this, '/specials/mywk')}>
                        <div className={classes(Styles.NavItemIcon,  this.state.isShowRedPot && Styles.showRedPot)} style={{backgroundImage: `url(${this.state.icons[1].normal})`}}/>
                    </div>
                    <div className={Styles.NavItem} onClick={this.linkTo.bind(this, '/account3/myaccount')}>
                        <img className={Styles.NavItemIcon} src={this.state.icons[2].normal} alt=""/>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Nav/Nav.tsx